import { PALETTE, SIZES, MQ_TABLET} from '../../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../../../components/common/responsive-dimension-values';

const WINDOW_WIDTH = ResponsiveDimensionValues.windowWidth;
const blue = '#13223b';
const borderColor = 'rgb(38,49,71)'

export default MediaQueryStyleSheet.create({
  root: {
    marginTop: 41,
    marginBottom: 141,
  },
  mainWrapper:{
     display: 'flex',
     justifyContent: 'flex-end'
  },
  modalstyle:{
    flex:1
  },
  cursorPointer:{
    cursor: 'pointer',width:'100%'
  },
  modalHeading:{
    paddingHorizontal: 10,
    paddingVertical: 15,
    color: PALETTE.secondaryActive,
  },

  paddingNull: {
    padding: 0
  },

  createBtn: {
    width: 170,
    height: 42,
    marginRight: 0,
  },
  displayFlex: {
    display: 'flex',
  },
  paymentListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  titleMargin: {
    display: 'flex',
    marginLeft: 15,
    color: PALETTE.primaryText
  },
  textColor: {
    // verticalAlign: 'top',
    marginLeft: 10,
    // marginTop: 10,
    position:'absolute',
    // color: PALETTE.secondaryText //Commented for dbk16 implementation
  }
}, {
    [MQ_TABLET]: {
      root: {
        width: WINDOW_WIDTH * 0.6,
        alignSelf: 'center',
        borderWidth: 2,
        borderColor: PALETTE.primaryStrokeLine,
        paddingVertical: 40,
        marginTop: 50,
      },
      mainWrapper: {
        flex: 1,
      },
      mainroot: {
        width: WINDOW_WIDTH * 0.6,
        alignSelf: 'center',
        borderWidth: 2,
        borderColor: PALETTE.primaryStrokeLine,
      },
      headline: {
        marginHorizontal: 0,
      },
      countrytext: {
        textAlign: 'left',
        paddingRight: 20,
        marginLeft: 20,
        flex: 0.7,
      },
      icon: {
        flex: 0.11,
      },
    }
  });

export const selectedSVGStyles = {
  radius: 4,
};

